var _style, _defs, _defs2, _rect, _defs3, _defs4, _rect2, _defs5, _defs6, _rect3, _defs7, _defs8, _rect4, _defs9, _defs10, _rect5, _defs11, _defs12, _defs13, _defs14, _defs15, _rect6, _defs16, _defs17, _rect7, _defs18, _defs19, _rect8, _defs20, _defs21, _rect9, _defs22, _defs23, _rect10, _defs24, _defs25, _rect11, _defs26, _defs27, _rect12, _defs28, _defs29, _rect13, _defs30, _defs31, _rect14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnreal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "231.7px",
    height: "240.7px",
    viewBox: "0 0 231.7 240.7",
    style: {
      enableBackground: "new 0 0 231.7 240.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#2E2E2C;}\n\t.st2{clip-path:url(#SVGID_6_);}\n\t.st3{clip-path:url(#SVGID_8_);fill:#2E2E2C;}\n\t.st4{clip-path:url(#SVGID_10_);}\n\t.st5{clip-path:url(#SVGID_12_);fill:#2E2E2C;}\n\t.st6{clip-path:url(#SVGID_14_);}\n\t.st7{clip-path:url(#SVGID_16_);fill:#2E2E2C;}\n\t.st8{clip-path:url(#SVGID_18_);}\n\t.st9{clip-path:url(#SVGID_20_);fill:#2E2E2C;}\n\t.st10{clip-path:url(#SVGID_22_);}\n\t.st11{clip-path:url(#SVGID_24_);enable-background:new    ;}\n\t.st12{clip-path:url(#SVGID_26_);}\n\t.st13{clip-path:url(#SVGID_28_);}\n\t.st14{clip-path:url(#SVGID_30_);fill:#2E2E2C;}\n\t.st15{clip-path:url(#SVGID_32_);}\n\t.st16{clip-path:url(#SVGID_34_);fill:#2E2E2C;}\n\t.st17{clip-path:url(#SVGID_36_);}\n\t.st18{clip-path:url(#SVGID_38_);fill:#2E2E2C;}\n\t.st19{clip-path:url(#SVGID_40_);}\n\t.st20{clip-path:url(#SVGID_42_);fill:#2E2E2C;}\n\t.st21{clip-path:url(#SVGID_44_);}\n\t.st22{clip-path:url(#SVGID_46_);fill:#2E2E2C;}\n\t.st23{clip-path:url(#SVGID_48_);}\n\t.st24{clip-path:url(#SVGID_50_);fill:#2E2E2C;}\n\t.st25{clip-path:url(#SVGID_52_);}\n\t.st26{clip-path:url(#SVGID_54_);fill:#2E2E2C;}\n\t.st27{clip-path:url(#SVGID_56_);}\n\t.st28{clip-path:url(#SVGID_58_);fill:#2E2E2C;}\n\t.st29{clip-path:url(#SVGID_60_);}\n\t.st30{clip-path:url(#SVGID_62_);fill:#2E2E2C;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M152,110.2c-3,0-4.2-1.8-4.2-1.8c-0.2-0.8-0.4-12.7-0.5-24.5c-0.1-12.3,0-24.5,0.6-24.6 c3.5-6.5,14.5-19.6,14.5-19.6c-20.6,4.1-31.8,17.6-31.8,17.6c-3.3-2.6-10.1-2.2-10.1-2.2c3.2,1.7,6.3,6.8,6.3,11v41.4 c0,0-6.9,6.1-12.2,6.1c-3.2,0-5.1-1.7-6.2-3.1c-0.7-1-1-1.8-1-1.8V57.6c-0.7,0.5-1.6,0.9-2.5,0.9c-1.1,0-2.3-0.6-3.1-2.2 c-0.6-1.3-1-3.1-1-5.9c0-9.4,10.7-15.7,10.7-15.7c-13.5,3.6-26.1,10.6-42.8,29.8c-16.7,19.2-13.5,35-13.5,35S59.7,88.5,70.8,77 c5.3-5.4,9.2-7.2,11.9-7.3c3,0,4.4,2.2,4.4,4.2v38.9c0,3.8-2.5,4.7-4.8,4.6c-1.9,0-3.7-0.7-3.7-0.7 c11.4,16.5,38.6,18.9,38.6,18.9l12-12.8l0.3,0.2l11,9.3c20-11.9,29.7-34,29.7-34C161.1,108,155.4,110.2,152,110.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 33.5,
    className: "st1",
    width: 117.6,
    height: 103.4
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M115.6,5.2c21.2,0,41.2,8.3,56.2,23.5c15,15.1,23.3,35.3,23.3,56.7c0,21.4-8.3,41.5-23.3,56.7 c-15,15.1-35,23.5-56.2,23.5s-41.2-8.3-56.2-23.5c-15-15.1-23.3-35.3-23.3-56.7c0-21.4,8.3-41.5,23.3-56.7 C74.4,13.5,94.3,5.2,115.6,5.2 M115.6,1.5C69.6,1.5,32.4,39,32.4,85.3c0,46.3,37.2,83.8,83.1,83.8s83.1-37.5,83.1-83.8 C198.7,39,161.5,1.5,115.6,1.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 0.3,
    className: "st3",
    width: 168.6,
    height: 170
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "73.6,238.3 55.8,238.3 55.8,222 73.3,222 73.3,225.6 60.6,225.6 60.6,228.4 72.6,228.4  72.6,231.8 60.6,231.8 60.6,234.6 73.6,234.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 220.9,
    className: "st5",
    width: 20.1,
    height: 18.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_13_",
    points: "97.7,238.3 90.6,238.3 81.1,226.1 81,226.1 81,238.3 76.3,238.3 76.3,222 83.6,222 92.9,234.3  93,234.3 93,222 97.7,222  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75.1,
    y: 220.9,
    className: "st7",
    width: 23.8,
    height: 18.7
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M111.6,238.5c-1.5,0-2.8,0-3.9-0.1c-1.1-0.1-2-0.2-2.8-0.4c-0.8-0.2-1.4-0.5-1.9-0.9 c-0.5-0.4-0.9-0.9-1.1-1.5c-0.3-0.6-0.4-1.3-0.5-2.2c-0.1-0.8-0.1-1.9-0.1-3V230c0-1.2,0-2.2,0.1-3c0.1-0.9,0.3-1.6,0.5-2.2 c0.3-0.6,0.6-1.1,1.1-1.4c0.5-0.4,1.1-0.7,1.9-0.9c0.8-0.2,1.7-0.3,2.8-0.4c1.1-0.1,2.4-0.1,3.9-0.1h0.7c1.3,0,2.4,0,3.3,0.1 c0.9,0.1,1.8,0.2,2.4,0.3c0.7,0.1,1.2,0.3,1.7,0.6c0.4,0.2,0.8,0.6,1,0.9c0.3,0.4,0.4,0.8,0.5,1.4c0.1,0.5,0.1,1.2,0.1,1.9v0.6 h-4.6v-0.2c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.3-0.3-0.5-0.7-0.6c-0.3-0.2-0.8-0.3-1.4-0.3c-0.6-0.1-1.4-0.1-2.4-0.1h-0.4 c-0.9,0-1.7,0-2.3,0c-0.6,0-1.2,0.1-1.6,0.2c-0.4,0.1-0.8,0.3-1,0.4c-0.2,0.2-0.4,0.5-0.6,0.8c-0.1,0.3-0.2,0.7-0.2,1.2 c0,0.5-0.1,1.1-0.1,1.8v0.3c0,0.7,0,1.3,0.1,1.7c0,0.5,0.1,0.9,0.2,1.2c0.1,0.3,0.3,0.6,0.6,0.8c0.2,0.2,0.6,0.3,1,0.4 c0.4,0.1,1,0.2,1.6,0.2c0.6,0,1.4,0,2.3,0h0.4c0.7,0,1.4,0,1.9,0c0.5,0,1-0.1,1.3-0.1c0.4-0.1,0.7-0.1,0.9-0.2 c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.3,0.2-0.6c0-0.2,0.1-0.5,0.1-0.7v-0.5h-6.2v-3.1h10.8v3.6c0,0.8-0.1,1.5-0.2,2.1 c-0.1,0.6-0.3,1.1-0.6,1.5c-0.3,0.4-0.6,0.8-1.1,1.1c-0.4,0.3-1,0.5-1.7,0.7s-1.5,0.3-2.5,0.4c-1,0.1-2.1,0.1-3.4,0.1H111.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100.1,
    y: 220.8,
    className: "st9",
    width: 22.8,
    height: 18.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 1.8,
    y: 184.5,
    width: 227.7,
    height: 54.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 133.3,
    y: 222.1,
    width: 42.8,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "154.6,238.3 147.5,238.3 138.1,226.2 138,226.2 138,238.3 133.4,238.3 133.4,222.2  140.6,222.2 149.9,234.3 150,234.3 150,222.2 154.6,222.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 1.8,
    y: 184.4,
    width: 227.7,
    height: 54.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 132.2,
    y: 221,
    className: "st14",
    width: 23.6,
    height: 18.5
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_31_",
    points: "176,238.3 158.4,238.3 158.4,222.2 175.7,222.2 175.7,225.7 163.1,225.7 163.1,228.5  175.1,228.5 175.1,231.9 163.1,231.9 163.1,234.7 176,234.7  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 1.8,
    y: 184.4,
    width: 227.7,
    height: 54.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 157.2,
    y: 221,
    className: "st16",
    width: 20,
    height: 18.5
  })))))))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M18.9,213.3c-2.3,0-4.3-0.1-6.1-0.2c-1.7-0.1-3.2-0.3-4.5-0.6c-1.3-0.3-2.3-0.7-3.1-1.2 c-0.8-0.5-1.5-1.2-2-1.9c-0.5-0.8-0.8-1.7-1-2.8c-0.2-1.1-0.3-2.3-0.3-3.7v-18.4h8.4v15.7c0,1,0,1.8,0.1,2.5 c0.1,0.7,0.2,1.3,0.4,1.8c0.2,0.5,0.5,0.9,0.9,1.2c0.4,0.3,0.9,0.5,1.6,0.7c0.6,0.2,1.4,0.3,2.4,0.3c0.9,0.1,2.1,0.1,3.4,0.1h0.7 c1.3,0,2.4,0,3.4-0.1c0.9-0.1,1.7-0.2,2.4-0.3c0.6-0.2,1.2-0.4,1.6-0.7c0.4-0.3,0.7-0.7,0.9-1.2c0.2-0.5,0.3-1.1,0.4-1.8 c0.1-0.7,0.1-1.5,0.1-2.5v-15.7h8.4v18.4c0,1.4-0.1,2.6-0.3,3.7c-0.2,1.1-0.5,2-1,2.8c-0.5,0.8-1.1,1.4-2,1.9 c-0.8,0.5-1.9,0.9-3.1,1.2c-1.3,0.3-2.8,0.5-4.5,0.6c-1.8,0.1-3.8,0.2-6.1,0.2H18.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 183.3,
    className: "st18",
    width: 37.4,
    height: 31.2
  })))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_39_",
    points: "80,213 67.5,213 51,191.7 50.8,191.7 50.8,213 42.6,213 42.6,184.5 55.3,184.5 71.7,205.8  71.8,205.8 71.8,184.5 80,184.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 183.3,
    className: "st20",
    width: 39.8,
    height: 30.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M119.6,213h-8.3v-2.3c0-0.8,0-1.5-0.1-2.2c-0.1-0.6-0.2-1.1-0.4-1.5c-0.2-0.4-0.5-0.8-0.9-1 c-0.4-0.3-0.9-0.4-1.6-0.6c-0.6-0.1-1.4-0.2-2.4-0.3c-0.9,0-2.1-0.1-3.4-0.1h-8.4v7.9h-8.3v-28.5H108c2.3,0,4.2,0.1,5.7,0.4 c1.5,0.3,2.7,0.8,3.5,1.4c0.9,0.7,1.5,1.6,1.8,2.7c0.3,1.1,0.5,2.5,0.5,4.1v1c0,1.1-0.1,2.1-0.3,2.9c-0.2,0.8-0.5,1.6-0.9,2.2 c-0.4,0.6-0.9,1.1-1.5,1.5c-0.6,0.4-1.4,0.7-2.3,0.9v0.2c1,0.2,1.8,0.4,2.5,0.6c0.6,0.3,1.1,0.6,1.5,1.1c0.4,0.5,0.6,1.2,0.7,2 c0.1,0.8,0.2,1.8,0.2,3.1V213z M104.6,198.9c1.4,0,2.6,0,3.5-0.1c0.9-0.1,1.5-0.3,2-0.6c0.4-0.3,0.7-0.7,0.9-1.2 c0.1-0.5,0.2-1.2,0.2-2v-0.5c0-0.8-0.1-1.5-0.2-2c-0.1-0.5-0.4-0.9-0.9-1.1c-0.5-0.3-1.1-0.4-2-0.5c-0.9-0.1-2-0.1-3.4-0.1H94.2 v8.1H104.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.7,
    y: 183.3,
    className: "st22",
    width: 36.1,
    height: 30.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_47_",
    points: "156.1,213 125,213 125,184.5 155.6,184.5 155.6,190.8 133.4,190.8 133.4,195.6 154.4,195.6  154.4,201.6 133.4,201.6 133.4,206.5 156.1,206.5  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 123.9,
    y: 183.3,
    className: "st24",
    width: 33.4,
    height: 30.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M198.9,213h-9.1l-2.6-5.1h-17.8l-2.6,5.1h-9l15.3-28.5h10.3L198.9,213z M184.2,201.9l-5.8-11.5h-0.2 l-5.8,11.5H184.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_53_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_54_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_53_",
    style: {
      overflow: "visible"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 156.7,
    y: 183.3,
    className: "st26",
    width: 43.4,
    height: 30.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_55_",
    points: "229.5,213 202,213 202,184.5 210.4,184.5 210.4,206.4 229.5,206.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_57_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 200.8,
    y: 183.3,
    className: "st28",
    width: 29.8,
    height: 30.9
  })))), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_59_",
    x: 125,
    y: 222.2,
    width: 4.8,
    height: 16.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_60_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_59_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_61_",
    x: -46.8,
    y: -94.5,
    width: 705.6,
    height: 470.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 123.8,
    y: 221,
    className: "st30",
    width: 7.1,
    height: 18.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreal);
export default __webpack_public_path__ + "static/media/unreal.ddd20873ec351ce07f2ec8eff8d7885f.svg";
export { ForwardRef as ReactComponent };